import React from 'react'
import StyledText from '../../../components/StyledComponents/StyledText';
import { useTheme } from '../../../middleware/ThemeContext';
import FormikInputField from '../../../components/Formik/FormikInputField';
import { MembershipTypeFormValues } from '../../../types/types';
import DeleteIcon from '../../../assets/icons/DeleteIcon';
import AddIcon from '../../../assets/icons/AddIcon';
import AlertNotice from '../dashboard/Components/AlertNotice';

interface MultiYearPricingAdd {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
    values: MembershipTypeFormValues;
}

const MultiYearPricingAdd: React.FC<MultiYearPricingAdd> = ({ values, setFieldValue }) => {
    const {theme} = useTheme();

    const addMultiYearOption = () => {
        const newOption = {
        option: Date.now(), // Unique ID using timestamp
        duration: 1,
        discountedPrice: 1,
        };
        
        setFieldValue("multiYearPricingOptions", [
        ...values.multiYearPricingOptions,
        newOption
        ]);
    };

    const removeMultiYearOption = (indexToRemove: any) => {
        const updatedOptions = values.multiYearPricingOptions.filter(
        (_, index) => index !== indexToRemove
        );
        setFieldValue("multiYearPricingOptions", updatedOptions);
    };

  return (
    <>
        <div className='d-flex'>
        <div className='col'>
            <StyledText 
            className="mb-2"
            textColor={theme.CorporateTheme?.colors?.headerColor}
            >
            Duration (Years)
            </StyledText>
        </div>
        <div className='col'>
            <StyledText 
            className="mb-2"
            textColor={theme.CorporateTheme?.colors?.headerColor}
            >
            Discounted Price
            </StyledText>
        </div>
        </div>
        {values.multiYearPricingOptions.map((option, index) => (
        <div className="d-flex align-items-center gap-3 mb-3" key={option.option || index}>
            {/* Duration Field */}
            <div className="col">
                <FormikInputField
                    // className="mb-3"
                    name={`multiYearPricingOptions[${index}].duration`}
                    value={option.duration}
                    type="number"
                    min={1}
                    // maxChar={120}
                    placeholder="Enter duration in years"
                    onChange={(e) => {
                    const updated = [...values.multiYearPricingOptions];
                    updated[index] = { ...updated[index], duration: Number(e.target.value) };
                    setFieldValue("multiYearPricingOptions", updated);
                    }}
                />
            </div>

            {/* Discounted Price Field */}
            <div className="col position-relative">
                <StyledText 
                    fontWeight={500}
                    textColor={theme.CorporateTheme.colors.textSecondary}
                    className='position-absolute' 
                    style={{ top: '14px', left: '13px', zIndex: '9' }}
                >$</StyledText>
                <FormikInputField
                    className="ps-4 pe-4"
                    name={`multiYearPricingOptions[${index}].discountedPrice`}
                    value={option.discountedPrice}
                    type="number"
                    min={1}
                    // maxChar={120}
                    placeholder="Enter discounted price"
                    onChange={(e) => {
                    const updated = [...values.multiYearPricingOptions];
                    updated[index] = { ...updated[index], discountedPrice: Number(e.target.value) };
                    setFieldValue("multiYearPricingOptions", updated);
                    }}
                />
                <StyledText
                    className='position-absolute'
                    textColor={theme.CorporateTheme.colors.textSecondary}
                    fontSize='12px'
                    fontWeight={400}
                    style={{
                    top: '9px',
                    right: '10px',
                    padding: '5px 0px',
                    backgroundColor: theme.CreateFormTheme.colors.inputBackground,
                    }}
                >
                    Per Year
                </StyledText>
            </div>
            <div className='cursor-pointer' onClick={() => removeMultiYearOption(index)}>
            <DeleteIcon />
            </div>
        </div>
        ))}

        <AlertNotice 
            message='Add different multi-year membership options. L3 members will see these options during checkout (e.g., 2-year plan, 3-year plan, etc.). The price you enter applies to the entire selected duration.'
        />

        <StyledText
            className="cursor-pointer mt-3 mb-4"
            textColor={theme.CorporateTheme.colors.blueberry}
            onClick={addMultiYearOption}
        >
            <AddIcon color={theme.CorporateTheme.colors.blueberry} />
            Add Duration Option
        </StyledText>
    </>
  )
}

export default MultiYearPricingAdd